<script>
import { mapActions } from 'vuex';
import ChaileaseContractPrint1 from '@/components/ChaileaseContractPrint1.vue';
import ChaileaseContractPrint2 from '@/components/ChaileaseContractPrint2.vue';
import ChaileaseContractPrint3 from '@/components/ChaileaseContractPrint3.vue';
import ChaileaseContractPrint4 from '@/components/ChaileaseContractPrint4.vue';
export default {
  name: 'ChaileaseContractView',
  components: { ChaileaseContractPrint1, ChaileaseContractPrint2, ChaileaseContractPrint3, ChaileaseContractPrint4 },
  data(){
    return {
      item: null,
      type: 0,
      version: 0,
      platform: 0
    }
  },
  async created() {
    this.caseId = this.$route.query.caseId;
    this.type = parseInt(this.$route.query.type, 10);
    this.platform = parseInt(this.$route.query.platform);
    console.log(`load ChaileaseContractView ${this.caseId}`)
    if (this.caseId){
      this.loadData();
    }
  },
  methods:{
    ...mapActions(["searchFinanceInfo", 'fetchFinanceCreditInfo']),
    async loadData(){
      try {
        this.fetchFinanceCreditInfo({ caseId: this.caseId }).then((results) => {
          if (results.length) {
            this.item = results[0];
          }
          console.log(`fetchFinanceCreditInfo = ${JSON.stringify( this.item )}`)
        });
        // const results = await this.fetchFinanceCreditInfo({ caseId: this.caseId });
        // if (Object.keys(results).length) {
        //   this.item = results[0];
        // }

      }catch (e) {
        console.log(`load data error `, e);
      }
    }
  }
};
</script>

<template>
  <div>
    <ChaileaseContractPrint1 v-if="type === 22" :item="item"/>

    <ChaileaseContractPrint2 v-if="type === 23" :item="item"/>

    <ChaileaseContractPrint3 v-if="type === 24" :item="item"/>

    <ChaileaseContractPrint4 v-if="type === 25" :item="item"/>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/ChaileaseContractView.vue